import React, { useState } from "react";
import { IManageAutomationProps } from "./ManageAutomation.types";

// import "./ManageAutomation.css";
import { Box, Grid } from "@mui/material";

import ReactFlow, {
  Node,
  ReactFlowProvider,
  Controls,
  useReactFlow,
  Background,
  BackgroundVariant,
  ProOptions,
  Edge,
} from "reactflow";

import "reactflow/dist/style.css";
import { ParentWorkflowNode } from "./ParentWorkflowNode/ParentWorkflowNode";
import {
  addPlaceholderNode,
  clearAutomationState,
} from "../../redux/automation/automation.reducer";


import useCursorStateSynced from "./utils/useCursorStateSynced";

import "reactflow/dist/style.css";
import {
  ICreateWorkflow,
} from "../../redux/automation/automation.types";
import { ConditionNode } from "./ConditionNode/ConditionNode";
import { ActionNode } from "./ActionNode/ActionNode";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FinishAction } from "./FinishAction/FinishAction";
import { PlaceholderNode } from "./PlaceholderNode/PlaceholderNode";
import { edgeTypes } from "./EdgeTypes/EdgeType";
import useLayout from "./utils/useLayout";
import { IBreadcrumbProps } from "../../layout/breadcrumb/IBreadcrumbProps";
import { IStoreState, useAppDispatch, useAppSelector } from "../../redux";
import { PageLoader } from "../../Components/PageLoader/PageLoader";
import { Breadcrumb } from "../../layout/breadcrumb/Breadcrumb";
import { StandardCard } from "../../Components/Card";
import { LoadState } from "../../constants/enum";
import { fetchAutomationAsync } from "../../redux/automation";

const proOptions: ProOptions = { account: "paid-pro", hideAttribution: true };

// initial setup: one workflow node and a placeholder node
// placeholder nodes can be turned into a workflow node by click
const defaultNodes: Node[] = [];

// initial setup: connect the workflow node to the placeholder node with a placeholder edge
const defaultEdges: Edge[] = [];

const fitViewOptions = {
  padding: 0,
};

const nodeTypes = {
  parentWorkflowNode: ParentWorkflowNode,
  placeholder: PlaceholderNode,
  conditionNode: ConditionNode,
  actionNodeEmail: ActionNode,
  actionNodeSMS: ActionNode,
  actionNodeWhatsApp: ActionNode,
  actionNodeModification: ActionNode,
  performEmailAction: FinishAction,
};

const ManageAutomationFlow: React.FC = () => {
  const { automationCode } = useParams() as { automationCode: string };
  const [counter, setCounter] = React.useState(0);
  useLayout(counter);

  const BCrumb: IBreadcrumbProps["items"] = [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: "/settings/automation",
      title: "workflows",
    },
    {
      title: automationCode ? "Edit Workflow" : "Create Workflow",
    },
  ];

  const { graphData, graphLoadState } = useAppSelector(
    (storeState: IStoreState) => storeState.automation
  );

  const { getNodes, getEdges, setNodes, setEdges } = useReactFlow();
  console.log("#---", graphData, getNodes(), getEdges());
  const [cursors, onMouseMove] = useCursorStateSynced();
  const { screenToFlowPosition } = useReactFlow();
  const location = useLocation();
  const navigate = useNavigate();
  const [openRightPanel, setOpenRightPanel] = useState<ICreateWorkflow | null>(
    null
  );
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (graphData) {
      setNodes(graphData.nodes);

      setEdges(graphData.edges);
      setCounter(counter + 1);
    }
  }, [graphData]);

  React.useEffect(() => {
    if (automationCode) {
      dispatch(fetchAutomationAsync(automationCode));
    } else {
      dispatch(addPlaceholderNode());
    }
  }, [automationCode]);

  React.useEffect(() => {
    return () => {
      dispatch(clearAutomationState());
    };
  }, []);

  return (
    <PageLoader loading={graphLoadState === LoadState.pending}>
      <Breadcrumb title="" items={BCrumb} />
      <StandardCard heading="Manage Automation" sx={{ height: "90vh", }}>
        <Grid container spacing={2} height={"94%"}>
          <Grid item xs={12} justifyContent={"center"}>
            <Box height={"100%"}>
              <ReactFlow
                defaultNodes={defaultNodes}
                defaultEdges={defaultEdges}
                proOptions={proOptions}
                fitView
                nodeTypes={nodeTypes as any}
                edgeTypes={edgeTypes}
                fitViewOptions={fitViewOptions}
                minZoom={0.2}
                maxZoom={1.6}
                nodesDraggable={false}
                nodesConnectable={false}
                zoomOnScroll={false}
                zoomOnDoubleClick={false}
                draggable={false}
                // we are setting deleteKeyCode to null to prevent the deletion of nodes in order to keep the example simple.
                // If you want to enable deletion of nodes, you need to make sure that you only have one root node in your graph.
                deleteKeyCode={null}
              >
                <Background color="#121212" style={{background: '#000'}} variant={BackgroundVariant.Lines} />
                <Controls  position="bottom-left" />
              </ReactFlow>
            </Box>
          </Grid>
        </Grid>
      </StandardCard>
    </PageLoader>
  );
};

export const ManageAutomation: React.FC<IManageAutomationProps> = (props) => {
  return (
    <ReactFlowProvider>
      <ManageAutomationFlow {...props} />
    </ReactFlowProvider>
  );
};
